/**
 * --------------------------------------------------------------------------
 * This file loads all required vendor scripts. Never import JS dependencies
 * that are used in multiple bundles in those separate file. This will
 * cause code duplication and therefore larger assets.
 * LET'S BEGIN SHALL WE..
 * -------------------------------------------------------------------------- */

try {
    // Polyfill all the things for older browsers
    require('core-js')

    // Polyfill Object-fit for IE Git: https://github.com/constancecchen/object-fit-polyfill
    require('objectFitPolyfill')

    // The http client
    window.axios = require('axios')

    // We need Vue
    window.Vue = require('vue')

    //lineClamp
    window.lineClamp = require('line-clamp')

    // jQuery... bah!
    window.$ = window.jQuery = require('jquery')

    // jQuery plugins.. 🤮
    require('slick-carousel')
    require('lightgallery')
} catch (e) {
    console.dir(e)
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

const token = document.head.querySelector('meta[name="csrf-token"]')

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content
} else {
    console.error('CSRF token not found')
}

/**
 * Component autoloader
 */

let components = require.context('./components/autoload', true, /\.vue$/i)
autoLoadVueComponents(components)

let moduleComponents = require.context('./../../../Modules', true, /\.vue$/i)
autoLoadVueComponents(moduleComponents)

function autoLoadVueComponents (components) {
    components.keys().map(key => {
        // Get the component name
        let explodedPath = key.split('/')
        let componentName = explodedPath[explodedPath.length - 1].split('.')[0]

        // Magic
        // eslint-disable-next-line no-undef
        return Vue.component(componentName, components(key).default)
    })
}
